import { useState, type FormEvent } from "react";

const FORM_ENDPOINT = "https://readdy.ai/api/form/dah7st3p14a1h3mr6eeg";

const eras = ["1990 年代", "2000 年代", "2010 年代", "2020 年代", "暂时说不好"];

const SubscribeForm = () => {
  const [status, setStatus] = useState<"idle" | "sending" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (status === "sending") return;

    const formData = new FormData(form);
    const auxValue = String(formData.get("website_alt") || "").trim();

    if (auxValue) {
      setStatus("success");
      setFormError("");
      return;
    }

    const payload = new URLSearchParams();
    formData.forEach((value, key) => {
      if (key === "website_alt") return;
      payload.append(key, typeof value === "string" ? value : value.name);
    });

    setStatus("sending");
    setFormError("");

    try {
      const response = await fetch(FORM_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });

      const responseText = await response.text();
      let parsed: {
        code?: string;
        message?: string;
        meta?: { message?: string; detail?: string };
      } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
      const isSpam = typeof serverMsg === "string" && serverMsg.toLowerCase().includes("spam");

      if (response.ok && parsed?.code === "OK" && !isSpam) {
        setStatus("success");
        form.reset();
        return;
      }

      setStatus("error");
      setFormError(serverMsg ? String(serverMsg) : "提交没有成功，请稍后再试一次。");
    } catch {
      setStatus("error");
      setFormError("网络好像出了问题，请检查连接后再提交。");
    }
  };

  return (
    <form
      id="subscribe-form"
      data-readdy-form
      onSubmit={handleSubmit}
      className="rounded-lg border border-foreground-950/10 bg-background-50 p-5 md:p-7"
    >
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <div>
          <label htmlFor="subscribe-email" className="font-label text-sm text-foreground-800">
            邮箱 <span className="text-primary-600">*</span>
          </label>
          <input
            id="subscribe-email"
            name="email"
            type="email"
            required
            placeholder="you@example.com"
            className="mt-2 w-full rounded-md border border-foreground-950/15 bg-background-100 px-3.5 py-2.5 text-sm text-foreground-950 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
          />
        </div>
        <div>
          <label htmlFor="subscribe-era" className="font-label text-sm text-foreground-800">
            你最想重温的年代
          </label>
          <select
            id="subscribe-era"
            name="era"
            defaultValue=""
            className="mt-2 w-full cursor-pointer rounded-md border border-foreground-950/15 bg-background-100 px-3.5 py-2.5 text-sm text-foreground-950 outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
          >
            <option value="" disabled>
              请选择
            </option>
            {eras.map((era) => (
              <option key={era} value={era}>
                {era}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="mt-4">
        <label htmlFor="subscribe-message" className="font-label text-sm text-foreground-800">
          线索或想说的话
        </label>
        <textarea
          id="subscribe-message"
          name="message"
          rows={3}
          maxLength={500}
          placeholder="例如：2007 年那档节目的完整录像，我手里还有一份……（不超过 500 字）"
          className="mt-2 w-full resize-none rounded-md border border-foreground-950/15 bg-background-100 px-3.5 py-2.5 text-sm text-foreground-950 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
        ></textarea>
      </div>

      <input
        className="field-note-aux"
        type="text"
        name="website_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
      />

      <div className="mt-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <p className="font-label text-xs text-foreground-500">
          我们只在整理进度和更正通知时联系你，不会用于其他用途。
        </p>
        <button
          type="submit"
          disabled={status === "sending"}
          className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-2.5 font-label text-sm text-background-50 transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-60"
        >
          <i className="ri-send-plane-line text-base"></i>
          {status === "sending" ? "提交中…" : "提交线索并订阅"}
        </button>
      </div>

      {status === "success" && (
        <p className="mt-4 flex items-center gap-2 rounded-md bg-secondary-100 px-3.5 py-2.5 font-label text-sm text-secondary-900">
          <i className="ri-checkbox-circle-line text-base"></i>
          收到了，谢谢。整理进度有更新时会通知你。
        </p>
      )}
      {status === "error" && (
        <p className="mt-4 flex items-center gap-2 rounded-md bg-primary-100 px-3.5 py-2.5 font-label text-sm text-primary-800">
          <i className="ri-error-warning-line text-base"></i>
          {formError}
        </p>
      )}
    </form>
  );
};

export default SubscribeForm;